const styles = theme => ({
    listItemHeader: {
        backgroundColor: theme.palette.background.paper
    },
    listItem: {
        width: '100%'
    }
});

export default styles;
